import React, { Suspense } from "react";
import "../Registration/Registration.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {

  Link,
  Redirect,
} from "react-router-dom";
import { Button,} from "reactstrap";
import Loading from "../../components/Loading";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import { connect } from "react-redux"
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";
import { useDispatch } from "react-redux";

const New_registration_for_users = (props) => {
  const { label ,auth} = props;
   const dispatch = useDispatch();
  const { frontLabelsName } = label
  const { isAuthenticated, loading } = auth;
  if (isAuthenticated && !loading) {
    return <Redirect to="/dashboard" />;
  }
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container">
        <div className="row">
          <div className="main-login-new">
            <div className="box-new-rg d-flex">
              <div className="col-lg-6 col-md-12">
                <div className="main-new-rg new-rh-ur">
                  <div className="contnet-new-rg ">
                    <p className="text-center cutom-fonts">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_create_your_account")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_create_your_account"
                          )[0]["value"] || "lbl_create_your_account"
                          : "lbl_create_your_account"
                        : "lbl_create_your_account"}
                    </p>
                    <div className="d-flex mt-4 mobile-mode align-items-center">
                      <div className="new-rg-img text-center">
                        <img src="assets/run.svg" alt="run" />
                      </div>
                      <div className="con-desc-main">
                        
                        <h6>4.700 - kr/{frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_month")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_month"
                          )[0]["value"] || "lbl_month"
                          : "lbl_month"
                        : "lbl_month"}</h6>
                      </div>
                    </div>
                    <div className="button-set pt-3">
                      <Link to="/access-by-otp" onClick={()=>{
                           dispatch({
                            type: "SET_IS_SUBSCRIBING",
                            payload: { isSubscribing: true },
                          });
                        localStorage.setItem("isSubscribing",true)
                          dispatch({
                            type:"SET_STEP",
                            payload:{step:0,status:false}
                         });
                        }}>
                        <Button>
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_new_registration")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_new_registration"
                              )[0]["value"] || "lbl_new_registration"
                              : "lbl_new_registration"
                            : "lbl_new_registration"}
                        </Button>
                      </Link>

                      <div className="set-bbn-content pt-4">
                        <p>
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_already_with_access")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_already_with_access"
                              )[0]["value"] || "lbl_already_with_access"
                              : "lbl_already_with_access"
                            : "lbl_already_with_access"}
                          <span>
                            <Link
                              to="/login"
                              style={{
                                textDecoration: "none",
                                color: "#fcd499",
                                paddingLeft: 5
                              }}
                            >
                              <b>
                                {frontLabelsName
                                  ? frontLabelsName.filter((e) => e.key == "lbl_check_in")
                                    .length > 0
                                    ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_check_in"
                                    )[0]["value"] || "lbl_check_in"
                                    : "lbl_check_in"
                                  : "lbl_check_in"}
                              </b>
                            </Link>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-12">
                <div className="main-new-rg new-rh-ur">
                  <div className="contnet-new-rg">
                    <p className="text-center cutom-fonts">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_subscribe_renters_list")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_subscribe_renters_list"
                          )[0]["value"] || "lbl_subscribe_renters_list"
                          : "lbl_subscribe_renters_list"
                        : "lbl_subscribe_renters_list"}
                    </p>
                    <div className="d-flex mt-4 mobile-mode align-items-center">
                      <div className="new-rg-img text-center">
                        <img src="assets/searchuser.svg" alt="run" />
                      </div>
                      <div className="con-desc-main">
                     
                        <h6>0 - kr</h6>
                      </div>
                    </div>
                    <div className="button-set pt-3">
                 
                      <Link to="/access-by-otp" onClick={()=>{
                           dispatch({
                            type: "SET_IS_SUBSCRIBING",
                            payload: { isSubscribing: false },
                          });
                         localStorage.setItem("isSubscribing",false)
                          dispatch({
                            type:"SET_STEP",
                            payload:{step:0,status:false}
                         });
                       }}>
                        <Button>
                        {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_new_registration")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_new_registration"
                              )[0]["value"] || "lbl_new_registration"
                              : "lbl_new_registration"
                            : "lbl_new_registration"}
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
});

export default connect(mapStateToProps, {})(New_registration_for_users);
